import http from "@/http";

let modulePath = "company/RenewBatch";

const post = function(path, data, config = {}) {
  return http.post(`${modulePath}/${path}`, data, config);
}

const get = function(path, config = {}) {
  return http.get(`${modulePath}/${path}`,config);
}

export default {
  getRenewBatchList(jwt) {
    return get("renewBatchList", {
      headers: {
        Authorization: "Bearer " + jwt
      },
    })
  },
  getResignedList(jwt, startDT, endDT, pageIndex, pageSize) {
    return get("resignedList", {
      headers: {
        Authorization: "Bearer " + jwt
      },
      params: {
        batchDateStart: startDT,
        batchDateEnd: endDT,
        pageIndex: pageIndex,
        pageSize: pageSize
      }
    })
  },
  getRenewStaffList(jwt, endDT, skip, size) {
    return get("renewStaffList", {
      headers: {
        Authorization: "Bearer " + jwt
      },
      params: {
        batchDateEnd: endDT,
        offsetTotal: skip,
        nextFetchTotal: size
      }
    })
  },
  getRenewStaffCount(jwt, endDT) {
    return get("renewStaffCount", {
      headers: {
        Authorization: "Bearer " + jwt
      },
      params: {
        batchDateEnd: endDT
      }
    })
  }, 
  postConfirm(jwt, formData) {
    return post("confirm", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + jwt
      }
    })
  },
  postGetExpiryDate(jwt, dataObj) {
    return post("getExpiryDate", dataObj, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt
      }
    })
  },
}